import {
  Document,
  Font,
  Image,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

type Approps = {
  qrCode: string;
  logo: string;
  text: null | string | undefined;
  category: string;
  description: string;
  assetId: string;
  subLocation: string;
  department: string;
  glCode: string;
};

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
      fontWeight: 600,
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf",
      fontWeight: 700,
    },
  ],
});

const MadePdf = ({
  qrCode,
  logo,
  text,
  category,
  description,
  assetId,
  subLocation,
  department,
  glCode,
}: Approps) => {
  const styles: any = StyleSheet.create({
    section: {
      float: "right",
      textAlign: "right",
    } as any,
    textSection: {
      // float: "left",
      marginTop: "5px",
      wordWrap: "break-word",
      fontSize: "8px",
      marginRight: "2px",
    } as any,

    finacId: {
      // display: "flex",
      // justifyContent: "center",
      // alignItems: "center",
      // border: "1px solid red",
    } as any,
    finacIdDiv: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      width: "60px",
      marginTop: "-7px",
    } as any,
    qrCodeContainer: {
      width: "80px",
      display: "flex",
      height: "80px",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      // position: "relative",
    } as any,
  });

  return (
    <Document>
      <Page wrap={false} orientation="landscape" size={[115, 192]}>
        <View
          style={{
            width: "188.97px",
            padding: "3px",
            height: "113.38px",
            textTransform: "uppercase",
            border: "0.5px solid #a1aabb",
            borderRadius: "5px",

            margin: "auto",
          }}
        >
          <View
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <View style={{ width: "60%" }}>
              <View
                style={{
                  width: "40px",
                  paddingTop: "3px",
                  height: "23px",
                }}
              >
                {logo && (
                  <Image
                    style={{
                      width: "40px",
                      height: "20px",
                    }}
                    src={logo ? logo : ""}
                  />
                )}
              </View>
              <View style={[styles.textSection]}>
                <Text>{glCode ? glCode : ""}</Text>
                <Text>{category ? category : ""}</Text>
                <Text>{department ? department : ""}</Text>
                <Text>{subLocation ? subLocation : ""}</Text>
                <Text>{description ? description : ""}</Text>
              </View>
            </View>
            <View style={styles.qrCodeContainer}>
              <View>
                {qrCode && (
                  <>
                    <View>
                      <Image
                        style={{
                          width: "80px",
                          height: "80px",

                          // padding: "5px",
                          // marginRight: "10px",
                        }}
                        src={qrCode ? qrCode : ""}
                      />
                    </View>
                  </>
                )}
              </View>
              <View style={styles.finacIdDiv}>
                <Text
                  style={[
                    styles.finacId,
                    {
                      fontFamily: "Open Sans",
                      fontSize: "8px",
                      fontWeight: "700",
                    },
                  ]}
                >
                  {text ? text : ""}
                </Text>
              </View>
            </View>
          </View>

          {/* </View> */}
        </View>
      </Page>
    </Document>
  );
};

export default MadePdf;
